export default "__VITE_ASSET__DRRQshb___"